export type Promotion = {
  id: number;
  headline: string;
  body?: string | null;
  imageKey?: string | null;
  imageUrl?: string | null;
  buttonLabel?: string | null;
  linkUrl?: string | null;
  startDate: string;
  endDate: string;
};

const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.kofc1056.org';

class PromotionsService {
  public async getActive(): Promise<Promotion[]> {
    try {
      const res = await fetch(`${API_BASE}/api/promotions/active`);
      if (!res.ok) return [];
      const rows = await res.json();
      return Array.isArray(rows) ? rows : [];
    } catch (ex) {
      console.error('Exception retrieving promotions', ex);
      return [];
    }
  }
}

export default PromotionsService;
